import { render } from "./BuildAvatarPanel.vue?vue&type=template&id=3e4c4f32&ts=true"
import script from "./BuildAvatarPanel.vue?vue&type=script&lang=ts"
export * from "./BuildAvatarPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__